import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';

import useQuery from '../../utils/useQuery';
import { validateLength } from '../../utils/validation';
import { sendPromocodeRedeemRequest } from '../../utils/api/storeApi';

import InputField from '../Enter/fields/InputField';
import SubmitButton from '../Enter/fields/SubmitButton';
import Spacer from '../common/Spacer';

import { genericErrorMessage } from '../../utils/lang/commonErrors';

import { isApiError } from '../../utils/api/clearApiClient';
import styles from './RedeemForm.scss';

const RedeemForm = () => {
  const history = useHistory();
  const intl = useIntl();
  const { code } = useQuery();

  const [codeValue, setCodeValue] = useState(code || '');
  const onCodeChange = (e) => setCodeValue(e.target.value);

  const [isLoading, setLoading] = useState(false);

  const [formErrors, setFormErrors] = useState({});
  const [errorClassName, setErrorClassName] = useState('');

  const onSubmit = () => {
    setLoading(true);
    setFormErrors({});
    setErrorClassName('');
    const validationError = validateLength(codeValue, 5, 50);

    if (codeValue.toUpperCase() === 'SAVEUKRAINE') {
      setErrorClassName(styles.greenError);
      setFormErrors({
        code: intl.formatMessage(
          {
            id: 'redeem.error.saveUkraine',
            defaultMessage:
              'The SAVEUKRAINE code has expired, but you can use the app for free now! Download from <link>here</link>.',
            description: 'Custom error for SAVEUKRAINE promo code, should direct user to download instead',
          },
          {
            link: (chunk) => (
              <a target="_blank" rel="noreferrer" href="https://clearvpn.com/apps/">
                {chunk}
              </a>
            ),
          },
        ),
      });
      setLoading(false);
    } else if (!validationError) {
      sendPromocodeRedeemRequest(codeValue)
        .then(() => {
          history.push('/promo/redeem/success');
        })
        .catch((err) => {
          if (isApiError(err) && err.response.data.code === 3) {
            setFormErrors({
              code: intl.formatMessage({
                id: 'redeem.error.wrongCode',
                defaultMessage: 'Code doesn’t exist or has been disabled',
                description: 'Error message indicating a wrong promo code has been submitted',
              }),
            });
          } else {
            setFormErrors({
              code: intl.formatMessage(genericErrorMessage),
            });
          }

          setLoading(false);
        });
    } else {
      setFormErrors({
        code: validationError,
      });
      setLoading(false);
    }
  };

  return (
    <form className={styles.form}>
      <h2 className={styles.title}>
        <FormattedMessage
          id="redeem.title"
          defaultMessage="Enter your code"
          description="Title of the page, where user can enter a promo code for some free premium time"
        />
      </h2>

      <Spacer height={1} />

      <InputField
        value={codeValue}
        onChange={onCodeChange}
        error={formErrors.code}
        placeholder={intl.formatMessage({
          id: 'redeem.inputPlaceholder',
          defaultMessage: 'Code',
          description: 'Placeholder of the input field for promo codes',
        })}
        errorClassName={errorClassName}
      />

      <SubmitButton
        text={intl.formatMessage({
          id: 'redeem.submit',
          defaultMessage: 'Apply',
          description: 'Submit button, applies promocode to the current users’ account',
        })}
        onSubmit={onSubmit}
        isLoading={isLoading}
      />
    </form>
  );
};

export default RedeemForm;
